var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outside-layout flow_down"},[_c('app-header',{staticClass:"sticky"}),_c('main',{staticClass:"flow_across outside-view"},[_vm._t("default")],2),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }